__turbopack_context__.v({
  "actions": "Sidebar-module__wECz5W__actions",
  "collapseButton": "Sidebar-module__wECz5W__collapseButton",
  "collapseChevron": "Sidebar-module__wECz5W__collapseChevron",
  "collapseIcon": "Sidebar-module__wECz5W__collapseIcon",
  "collapsed": "Sidebar-module__wECz5W__collapsed",
  "content": "Sidebar-module__wECz5W__content",
  "header": "Sidebar-module__wECz5W__header",
  "logo": "Sidebar-module__wECz5W__logo",
  "mobileDrawer": "Sidebar-module__wECz5W__mobileDrawer",
  "mobileFab": "Sidebar-module__wECz5W__mobileFab",
  "navigation": "Sidebar-module__wECz5W__navigation",
  "sidebar": "Sidebar-module__wECz5W__sidebar",
  "sidebarPaper": "Sidebar-module__wECz5W__sidebarPaper",
});
